import React from 'react';
import PropTypes from 'prop-types';

const TrendArrow = ({ color, className, style }) => {
  return (
    <svg width="19px" height="16px" viewBox="0 0 19 16" version="1.1" xmlns="http://www.w3.org/2000/svg" className={className} style={style}>
    <defs>
        <filter x="-3.0%" y="-2.3%" width="105.9%" height="104.5%" filterUnits="objectBoundingBox" id="filter-1">
            <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0.68627451   0 0 0 0 0.756862745   0 0 0 0 0.882352941  0 0 0 1 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                <feMergeNode in="SourceGraphic"></feMergeNode>
            </feMerge>
        </filter>
        <path d="M10.2889087,7.98333333 C10.7014087,7.98333333 10.9764087,7.71666667 10.9764087,7.31666667 C10.9764087,7.11666667 10.9076587,6.98333333 10.7701587,6.85 L6.02640873,0.25 C5.75140873,-0.0833333333 5.13265873,-0.0833333333 4.92640873,0.25 L0.11390873,6.91666667 C-0.0235912703,7.11666667 -0.0235912703,7.38333333 0.0451587297,7.58333333 C0.18265873,7.85 0.38890873,7.98333333 0.66390873,7.98333333 L10.2889087,7.98333333 C10.2889087,7.98333333 10.2889087,7.98333333 10.2889087,7.98333333 Z" id="path-2"></path>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="dashboard" transform="translate(-736.000000, -603.000000)">
            <g id="Organism/Stats-Block" filter="url(#filter-1)" transform="translate(517.000000, 410.000000)">
                <g id="Widget/Trends-Mini" transform="translate(223.000000, 191.000000)">
                    <g id="Icon/12x9/ArrowUp" transform="translate(0.000000, 4.000000)">
                        <mask id="mask-3" fill="white">
                            <use href="#path-2"></use>
                        </mask>
                        <use id="Shape" fill={color} fillRule="nonzero" href="#path-2"></use>
                        <g id="Color/System/Green-2" mask="url(#mask-3)" fill={color} fillRule="evenodd">
                            <rect x="-2.84217094e-14" y="-5.68434189e-14" width="11" height="8"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
  );
};

TrendArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default TrendArrow;
